import classNames from 'classnames'
import { BrazeBanner } from '~/components'
import { SectionContainer } from '../../components/SectionContainer'
import { BrazeBannerCardProps } from './BrazeBannerCard.types'

export const BrazeBannerCard = ({
  bannerPlacementId,
  containerWidth,
  topMargin,
  bottomMargin,
  leftMargin,
  rightMargin,
  wrapperClassName,
}: BrazeBannerCardProps) => {
  return (
    <SectionContainer
      width={containerWidth}
      wrapperClassName={classNames('overflow-hidden', wrapperClassName)}
      wrapperStyle={{
        marginTop: topMargin,
        marginBottom: bottomMargin,
        marginLeft: leftMargin,
        marginRight: rightMargin,
      }}>
      <BrazeBanner placementId={bannerPlacementId} />
    </SectionContainer>
  )
}
